import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

import { Button, ButtonGroup, Tooltip } from '@mui/material';
import BorderBottomIcon from '@mui/icons-material/BorderBottom';
import BorderLeftIcon from '@mui/icons-material/BorderLeft';
import BorderTopIcon from '@mui/icons-material/BorderTop';
import BorderRightIcon from '@mui/icons-material/BorderRight';
import BorderOuterIcon from '@mui/icons-material/BorderOuter';

const BorderStyle = ({ options = [] }) => {
  const { t } = useTranslation();
  const [isAll, setIsAll] = useState(false);

  const {
    actions: { setProp },
    borderLeft,
    borderBottom,
    borderTop,
    borderRight,
  } = useNode(({ data: { props } }) => {
    return {
      borderLeft: props.borderLeft,
      borderBottom: props.borderBottom,
      borderTop: props.borderTop,
      borderRight: props.borderRight,
    };
  });

  const fieldValue = {
    borderLeft,
    borderRight,
    borderTop,
    borderBottom,
    borderAll: isAll,
  };

  useEffect(() => {
    if (borderLeft && borderBottom && borderTop && borderRight) {
      setIsAll(true);
    } else {
      setIsAll(false);
    }
  }, [borderLeft, borderBottom, borderTop, borderRight]);

  const onClick = (event) => {
    const fieldName = event?.currentTarget?.name;
    if (fieldName === 'borderAll') {
      if (isAll) {
        setProp((props) => {
          props.borderLeft = false;
          props.borderBottom = false;
          props.borderTop = false;
          props.borderRight = false;
        }, 500);
      } else {
        setProp((props) => {
          props.borderLeft = true;
          props.borderBottom = true;
          props.borderTop = true;
          props.borderRight = true;
        }, 500);
      }
    } else {
      setProp((props) => {
        props[fieldName] = !Boolean(fieldValue[fieldName]);
      }, 500);
    }
  };

  const renderIcon = (iconName) => {
    switch (iconName) {
      case 'top':
        return <BorderTopIcon />;
      case 'bottom':
        return <BorderBottomIcon />;
      case 'left':
        return <BorderLeftIcon />;
      case 'right':
        return <BorderRightIcon />;
      case 'all':
        return <BorderOuterIcon />;
      default:
        return '';
    }
  };

  return (
    <div style={{ display: 'block' }}>
      <ButtonGroup
        disableElevation
        sx={{ border: 'none' }}
        aria-label='Basic button group'
        size='small'
      >
        {options.map((option) => (
          <Tooltip key={option.name} title={t(option.label)}>
            <Button
              name={option.name}
              onClick={onClick}
              sx={(theme) => ({
                p: 1,
                '& span': {
                  m: 0,
                },
                backgroundColor: theme.palette.secondary.light,
                color: fieldValue[option.name]
                  ? theme.palette.secondary.dark
                  : theme.common.buttonInactive,
                border: `none`,
              })}
              startIcon={renderIcon(option.iconName)}
            />
          </Tooltip>
        ))}
      </ButtonGroup>
    </div>
  );
};

export default BorderStyle;
